import React, {FunctionComponent} from "react";
import {ActionFieldProps} from "../../features/actions/common/commonTypes";
import SubtleRadio from "./SubtleRadio";
import {harvestErrors} from "./SubtleTextBox";

const IsExclusiveInput: FunctionComponent<ActionFieldProps> = (
    {
        formState,
        resetField,
        validatingRegister,
        mutationResults
    }
    ) => {
    return <SubtleRadio
        showLabel
        name='isDependent'
        options={[
            {name: 'true', label: 'Exclusive'},
            {name: 'false', label: 'Shared'},
        ]}
        alignItems={'center'}
        justifyContent={'space-between'}
        inline={true}
        label="Is Exclusive"
        validatingRegister={validatingRegister}
        isDirty={Boolean(formState.dirtyFields.isExclusive)}
        onReset={() => resetField('isExclusive')}
        {...validatingRegister('isExclusive')}
        error={harvestErrors(
            'isExclusive',
            formState,
            mutationResults
        )}
    />;
};

export default IsExclusiveInput;
